export const organization = {
  routes: [
    {
      path: "/organization/file-approval-survey/:id/survey",
      component: () => import("../organization-file-approval-survey-view"),
    },
    {
      path: "/organization/file-approval-survey/file/:id/survey/:id/members",
      component: () => import("../organization-file-approval-survey-members-view"),
    },
    {
      path: "/organization/file-approval-survey/file/:fileId/survey/:surveyId/results",
      component: () => import("../organization-file-approval-survey-results-view"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/file-approval-survey/:id/survey",
      component: () => import("../organization-file-approval-survey-view"),
    },
    {
      path: "/kvkk/file-approval-survey/file/:id/survey/:id/members",
      component: () => import("../organization-file-approval-survey-members-view"),
    },
    {
      path: "/kvkk/file-approval-survey/file/:fileId/survey/:surveyId/results",
      component: () => import("../organization-file-approval-survey-results-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/file-approval-survey/:id/survey",
      component: () => import("../organization-file-approval-survey-view"),
    },
    {
      path: "/gdpr/file-approval-survey/file/:id/survey/:id/members",
      component: () => import("../organization-file-approval-survey-members-view"),
    },
    {
      path: "/gdpr/file-approval-survey/file/:fileId/survey/:surveyId/results",
      component: () => import("../organization-file-approval-survey-results-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/file-approval-survey/:id/survey",
      component: () => import("../organization-file-approval-survey-view"),
    },
    {
      path: "/bgys/file-approval-survey/file/:id/survey/:id/members",
      component: () => import("../organization-file-approval-survey-members-view"),
    },
    {
      path: "/bgys/file-approval-survey/file/:fileId/survey/:surveyId/results",
      component: () => import("../organization-file-approval-survey-results-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/file-approval-survey/:id/survey",
      component: () => import("../organization-file-approval-survey-view"),
    },
    {
      path: "/ddo/file-approval-survey/file/:id/survey/:id/members",
      component: () => import("../organization-file-approval-survey-members-view"),
    },
    {
      path: "/ddo/file-approval-survey/file/:fileId/survey/:surveyId/results",
      component: () => import("../organization-file-approval-survey-results-view"),
    },
  ],
};
